<template>
  <a-dialog v-model="show" width="900px" max-width="80vw" persistent scrollable>
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span>{{ $t("agenda.lblLogHistory") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>
      </v-banner>
      <v-card-text style="color: black" class="pa-1">
        <a-data-table
          :headers="headers"
          :items="getMomLogs"
          dense
          fixed-header
          :items-per-page="15"
          style="width: 100%"
          :footer-props="{
            'items-per-page-text': $t('lblRowsPerPage'),
          }"
        >
          <template v-slot:[`item.updated_time`]="{ item }">
            {{ getTimeDetails(item.updated_time) }}
          </template>
          <template v-slot:[`item.user_email`]="{ item }">
            <div class="d-flex justify-space-between">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on"
                    >{{ userName(item.user_email) }}
                  </span>
                </template>
                <span>{{ item.user_email }} </span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:[`item.operation`]="{ item }">
            <div class="d-flex justify-space-between">
              <div style="word-break: break-word; width: 100%">
                {{
                  item.operation == "POST"
                    ? item.type === "document"
                      ? $t("lblUploaded")
                      : $t("lblAdded")
                    : item.operation == "PUT"
                    ? $t("lblUpdated")
                    : item.operation == "DELETE"
                    ? $t("lblDeleted")
                    : item.operation == "GET" && item.type === "document"
                    ? $t("lblDownloaded")
                    : ""
                }}
                <span v-if="item.type === 'document'">{{
                  item.file_name
                }}</span>
                <span v-else>{{ $t("agenda.lblComment") }}</span>
              </div>
            </div>
          </template>
        </a-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              color="secondary"
              small
              @click="close()"
              v-bind="attrs"
              v-on="on"
              ><span>{{ $t("btnClose") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnClose") }} </span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import {
  convertIntlDateFormat,
  formatDate,
  getTimeDetails,
} from "@/utils/util";
export default {
  name: "ViewLogDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      transcript_step: 1,
    };
  },
  computed: {
    ...mapGetters({
      getMomLogs: "meeting/getMomLogs",
    }),
    ...mapState({
      userList: (state) => state.people.userList,
    }),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    commentDateFormat() {
      return this.selectedLang !== "ja"
        ? "yyyy/MM/dd HH:mm aaa"
        : "yyyy/MM/dd HH:mm aaa";
    },
    headers() {
      return [
        {
          text: this.$t("activity.time"),
          align: "left",
          value: "updated_time",
          class: "header header-text",
          dataType: "Date",
          width: "220px",
          filterable: false,
        },
        {
          text: this.$t("activity.user"),
          align: "left",
          value: "user_email",
          class: "header header-text",
          filterable: true,
        },
        {
          text: this.$t("activity.activity"),
          align: "left",
          value: "operation",
          class: "header header-text",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    convertIntlDateFormat,
    getTimeDetails,
    close() {
      this.$emit("input", false);
    },
    filesChange() {
      this.transcript_step = 2;
    },
    logDate(logDate) {
      return formatDate(new Date(logDate), this.commentDateFormat);
    },
    userName(email) {
      const result = this.userList.find(
        (item) => item.registered_email == email
      );
      if (result) {
        return `${result.firstName} ${result.lastName}`;
      } else {
        return email;
      }
    },
  },
};
</script>

<style scoped>
.error-element {
  color: var(--v-error-base) !important;
}
::v-deep .v-toolbar__content {
  height: 45px !important;
}
.comment-status {
  display: contents;
}
</style>